import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class HeaderComponent implements OnInit {
  @Input("pageTitle") pageTitle;
  @Output() public back = new EventEmitter<String>();

  constructor() {}

  ngOnInit() {}
}
